function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const ToggleField = ({
  name,
  label,
  checked,
  onChange,
  inputRef,
  className = '',
  style = {},
  ...rest
}) => {
  const [isChecked, setIsChecked] = useState(false);
  useEffect(() => {
    setIsChecked(Boolean(checked));
    onChange(Boolean(checked));
  }, []);

  const handleChange = e => {
    e.preventDefault();
    setIsChecked(!isChecked);
    if (onChange) onChange(!isChecked);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: `form-group input-toggle ${className}`,
    style: style
  }, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: name
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "input-toggle__button",
    onClick: handleChange
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-toggle__base"
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames('input-toggle--circle', {
      checked: isChecked,
      unchecked: !isChecked
    })
  })), /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    name: name,
    ref: inputRef
  }, rest)));
};

ToggleField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  inputRef: PropTypes.func
};
export default ToggleField;